import React, { FC } from 'react';

import { LinkListBlock as Molecule } from '@components/Molecules';

export const LinkLists: FC<any> = ({ heading, linkLists }) => {
  const data = { heading, linkLists };
  return <Molecule data={data} />;
};
